<template>
  <div class="error-page">
    <!--header start-->
    <header-section></header-section>
    <!-- Header end -->
    <div class="container-fluid errorContent text-center">
      <div class="col-12 mt-4 f-lato c-color f-s-20"><img class="" :src="getAgentImage()" style="height: 50%;" alt="Agent"></div>
      <p class="heading f-lato mb-1 mt-5">Sorry, we could not find that page.</p>
      <button class="btn text-decoration-underline theme-font" @click.prevent="previousPage()">Go back to the previous page</button>
    </div>
    <div class="container-fluid p-0 mt-5">
        <FooterSection></FooterSection>
    </div>
  </div>
</template>
<script> 

import { defineAsyncComponent } from 'vue' 
import HeaderSection from '../section/HeaderSection.vue';


export default {
  components: {
    HeaderSection,
    FooterSection: defineAsyncComponent(() => import(`../../../../../config/${process.env.VUE_APP_CLIENT_PREFIX}/component/FooterSection.vue`)),
  },
  methods: {
    getAgentImage() {
      return require(`../../../../../config/${this.$theme.clientFolder}/assets/agent.png`);
    },
    previousPage() {
      let pageNames = [
        {key : "InsuranceInfo",
        value : "insurance-info"},
        {key : "VehicleInfo",
        value  : "vehicle-info"},
        {key : "DriverInfo",
        value :"driver-info"},
        {key : "DetailsInfo",
        value :"details-info"},
        {key : "Quote",
        value :"thankyouPage"}
      ]
      let currPage = sessionStorage.getItem('currentPageName');
      let page = '';
      for (let pageName of pageNames) {    
        if (pageName.key == currPage) {
            page = pageName.value;
            console.log("page",page)
            break;
        }
      }

      this.$router.push({ path: '/auto/'+page})
    }
  }
}
</script>
<style>
</style>